import type { AnyObjectSchema } from "yup";
import { mixed, object } from "yup";

import type { I18nT } from "@lib/dashboardI18n";
import "@lib/messageComposition/chatMessaging/yupHelper";
import sharedConstants from "@lib/shared_constants";
import { toAnyObjectSchema } from "@lib/yup";

import { getRcsMediaRichCardSchema } from "./rcsMediaRichCardSchema";
import { getRcsTextRichCardSchema } from "./rcsTextRichCardSchema";
import type { RcsRichCardMessageExport, RcsRichCardType } from ".";

export const richCardTypes = {
  text: getRcsTextRichCardSchema,
  media: getRcsMediaRichCardSchema,
} as Record<RcsRichCardType, (t: I18nT<"rcs-composer">, isTwilioProvider?: boolean) => AnyObjectSchema>;

export const getRcsRichCardSchema = (
  t: I18nT<"rcs-composer">,
  message: RcsRichCardMessageExport,
  isTwilioProvider?: boolean
): AnyObjectSchema =>
  message?.rich_card_type && !!richCardTypes[message?.rich_card_type as RcsRichCardType]
    ? richCardTypes[message?.rich_card_type as RcsRichCardType](t, isTwilioProvider)
    : toAnyObjectSchema(
        object({
          rich_card_type: mixed<RcsRichCardType>()
            .oneOf(Object.values(sharedConstants.RCS.RICH_CARD_TYPES))
            .required(t("invalid-rcs-rich-card-type", "Selecting an RCS rich card type is required")),
        })
      );
